<template>
  <div>
    <v-col>
      <v-sheet class="iol-used-inputs-v-sheet" :outlined="isOutlined">
        <h3 :hidden="!isControlateral">
          Controlateral Operated Eye Information
        </h3>
        <v-row class="justify-space-between">
          <v-col cols="3">
            AL: {{ fields.al || '--' }} mm <br />
            K1: {{ fields.k1 || '--' }} D <br />
            K2: {{ fields.k2 || '--' }} D <br />
            ACD: {{ fields.acd || '--' }} mm <br />
          </v-col>
          <v-col cols="6">
            {{ fields.aconst_title }}: {{ fields.aconst || '--' }} <br />
            <div v-if="!isControlateral">
              {{ fields.target_title }}: {{ fields.target || '--' }} D<br />
            </div>
            <div v-else>
              {{ fields.se2_title }}: {{ fields.se2 || '--' }} D<br />
              {{ fields.power2_title }}: {{ fields.power2 || '--' }} D<br />
            </div>
          </v-col>
          <v-col cols="3">
            LT: {{ fields.lt || '--' }} mm <br />
            CCT: {{ fields.cct || '--' }} μm <br />
            <div v-if="fields.total_corneal_power_measurement">
              {{ fields.total_corneal_power_measurement_title }} :
              {{ fields.total_corneal_power_measurement }}
              {{ fields.total_corneal_power_measurement_unit }}
            </div>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </div>
</template>

<style></style>

<script>
export default {
  name: 'iol-result-used-param',
  props: ['fields'],
  data() {
    return {
      field: this.fields,
    }
  },
  created() {
    this.$emit('fields', this.field)
  },
  computed: {
    isOutlined() {
      return this.field.is_outlined !== undefined && this.field.is_outlined
    },
    isRegular() {
      return (
        this.field.inputs_type !== undefined &&
        this.field.inputs_type.includes('regular')
      )
    },
    isComplex() {
      return (
        this.field.inputs_type !== undefined &&
        this.field.inputs_type === 'complex'
      )
    },
    isSecond() {
      return (
        this.field.inputs_type !== undefined &&
        this.field.inputs_type === 'second'
      )
    },
    isControlateral() {
      return (
        this.field.inputs_type !== undefined &&
        this.field.inputs_type === 'controlateral'
      )
    },
  },
}
</script>
<style scoped>
.iol-used-inputs-v-sheet {
  padding: 10px;
  background-color: inherit !important;
}
</style>
